"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = require("./Util");
var lodash_1 = require("lodash");
var EventFactory_1 = require("./EventFactory");
var Util_2 = require("./Util");
var jquery_1 = __importDefault(require("jquery"));
var BlockViewStateManager = (function () {
    function BlockViewStateManager() {
        this.blockStates = new Map();
        this.stateTimestamp = (0, Util_1.millisOnPage)();
    }
    BlockViewStateManager.prototype.millisSinceCurrent = function () {
        var _a;
        var pageMillis = (0, Util_1.millisOnPage)();
        return Math.abs(pageMillis - ((_a = this.stateTimestamp) !== null && _a !== void 0 ? _a : 0));
    };
    BlockViewStateManager.prototype.updateViewDurationsForNow = function () {
        var _this = this;
        var viewStates = [];
        var millisSinceCurrent = this.millisSinceCurrent();
        if (this.stateTimestamp != null) {
            this.blockStates.forEach(function (blockState, blockId) {
                var _a, _b;
                if (_this.wasInView(blockId)) {
                    blockState.durationMillis += millisSinceCurrent * ((_a = blockState === null || blockState === void 0 ? void 0 : blockState.percentageOfView) !== null && _a !== void 0 ? _a : 0);
                    blockState.durationChange = (0, Util_1.capDuration)(millisSinceCurrent) * ((_b = blockState === null || blockState === void 0 ? void 0 : blockState.percentageOfView) !== null && _b !== void 0 ? _b : 0);
                    viewStates.push(blockState);
                }
            });
        }
        return viewStates;
    };
    BlockViewStateManager.prototype.setTimestampToNow = function (millisNow) {
        this.stateTimestamp = millisNow;
    };
    BlockViewStateManager.prototype.updateBlockState = function (blockInfo, percentageOfView) {
        var _a, _b;
        var blockId = blockInfo.blockId, blockName = blockInfo.blockName, blockType = blockInfo.blockType;
        var newBlockState = {
            percentageOfView: percentageOfView,
            blockId: blockId,
            blockName: blockName,
            blockType: blockType,
            durationMillis: (_b = (_a = this.blockStates.get(blockId)) === null || _a === void 0 ? void 0 : _a.durationMillis) !== null && _b !== void 0 ? _b : 0,
            durationChange: 0,
        };
        this.blockStates.set(blockId, newBlockState);
    };
    BlockViewStateManager.prototype.wasInView = function (blockId) {
        var _a, _b;
        return ((_b = (_a = this.blockStates.get(blockId)) === null || _a === void 0 ? void 0 : _a.percentageOfView) !== null && _b !== void 0 ? _b : 0) > 0;
    };
    BlockViewStateManager.prototype.clearViewState = function () {
        this.blockStates.forEach(function (blockState) {
            blockState.percentageOfView = 0;
        });
        this.stateTimestamp = null;
    };
    BlockViewStateManager.prototype.getTotalBlockTimes = function () {
        return Array.from(this.blockStates.values()).reduce(function (previousValue, theState) { return previousValue + theState.durationMillis; }, 0);
    };
    return BlockViewStateManager;
}());
var buildBlockVisibilityFractionMap = function (visibleBlocks) {
    var e_1, _a;
    var fractionMap = new Map();
    var blockIdInfoMap = new Map();
    try {
        for (var visibleBlocks_1 = __values(visibleBlocks), visibleBlocks_1_1 = visibleBlocks_1.next(); !visibleBlocks_1_1.done; visibleBlocks_1_1 = visibleBlocks_1.next()) {
            var block = visibleBlocks_1_1.value;
            var fractionInView = (0, Util_1.calculatePercentageOfView)(block);
            var blockId = (0, Util_1.blockIdForBlock)((0, jquery_1.default)(block));
            var _b = (0, Util_1.blockDetailsForBlockElement)((0, jquery_1.default)(block)), blockName = _b.blockName, blockType = _b.blockType;
            if (blockId && blockName && blockType) {
                fractionMap.set(blockId, fractionInView);
                blockIdInfoMap.set(blockId, { blockName: blockName, blockType: blockType });
            }
            else {
                console.warn("No block id found for html element ".concat(block));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (visibleBlocks_1_1 && !visibleBlocks_1_1.done && (_a = visibleBlocks_1.return)) _a.call(visibleBlocks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { fractionMap: fractionMap, blockIdInfoMap: blockIdInfoMap };
};
var normaliseBlockFractions = function (fractionMap, sumFractions) {
    var normalisedFraction = function (value, sumFractions) { return value / sumFractions; };
    fractionMap.forEach(function (value, blockId, fractionMap) {
        fractionMap.set(blockId, normalisedFraction(value, sumFractions));
    });
    return fractionMap;
};
var BlockViewTracker = (function () {
    function BlockViewTracker() {
    }
    BlockViewTracker.init = function (eventSender) {
        BlockViewTracker.eventSender = eventSender;
        BlockViewTracker.currentBlockViewState = new BlockViewStateManager();
    };
    BlockViewTracker.start = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("Starting block view tracker");
                        BlockViewTracker.scrollListener = (0, jquery_1.default)(window).on("scroll", BlockViewTracker.debouncedTrackBlockState());
                        BlockViewTracker.resizeListener = (0, jquery_1.default)(window).on("resize", BlockViewTracker.debouncedTrackBlockState());
                        return [4, BlockViewTracker.trackBlockState()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    BlockViewTracker.stop = function () {
        return __awaiter(this, void 0, Promise, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        console.log("Stopping block view tracker");
                        return [4, BlockViewTracker.sendSnapshotOfBlockViewDurations()];
                    case 1:
                        _a.sent();
                        BlockViewTracker.scrollListener.off();
                        BlockViewTracker.resizeListener.off();
                        BlockViewTracker.clearViewState();
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        (0, Util_2.handleError)(err_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    BlockViewTracker.buildCurrentBlockViewEvents = function () {
        var latestViewStates = BlockViewTracker.currentBlockViewState.updateViewDurationsForNow();
        var pageTrackingInfo = (0, Util_1.getPageTrackingInfo)(window);
        if (pageTrackingInfo) {
            return latestViewStates.map(function (blockState) {
                return EventFactory_1.PageAnalyticsEventFactory.buildBlockViewDurationEvent((0, Util_1.getPageTrackingInfo)(window), blockState);
            });
        }
        return [];
    };
    BlockViewTracker.sendSnapshotOfBlockViewDurations = function () {
        return __awaiter(this, void 0, Promise, function () {
            var blockViewEvents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        blockViewEvents = BlockViewTracker.buildCurrentBlockViewEvents();
                        if (!(blockViewEvents.length > 0)) return [3, 2];
                        return [4, BlockViewTracker.eventSender.send(blockViewEvents).catch(Util_2.handleError)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    BlockViewTracker.debouncedTrackBlockState = function () {
        return (0, lodash_1.debounce)(BlockViewTracker.trackBlockState, 1000, { trailing: true });
    };
    BlockViewTracker.trackBlockState = function () {
        return __awaiter(this, void 0, Promise, function () {
            var currentMillis, visibleBlocks;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentMillis = (0, Util_1.millisOnPage)();
                        return [4, BlockViewTracker.sendSnapshotOfBlockViewDurations()];
                    case 1:
                        _a.sent();
                        visibleBlocks = (0, Util_1.getVisibleBlocks)();
                        BlockViewTracker.refreshBlockStates(visibleBlocks);
                        BlockViewTracker.resetStateTimestamp(currentMillis);
                        return [2];
                }
            });
        });
    };
    BlockViewTracker.refreshBlockStates = function (visibleBlocks) {
        var _a = buildBlockVisibilityFractionMap(visibleBlocks), fractionMap = _a.fractionMap, blockIdInfoMap = _a.blockIdInfoMap;
        var sumFractions = Array.from(fractionMap.values()).reduce(function (previousValue, currentValue) { return previousValue + currentValue; }, 0);
        if ((0, lodash_1.round)(sumFractions, 2) < 1.0) {
            fractionMap = normaliseBlockFractions(fractionMap, sumFractions);
        }
        BlockViewTracker.clearViewState();
        fractionMap.forEach(function (fraction, blockId) {
            var blockInfo = blockIdInfoMap.get(blockId);
            if (blockInfo) {
                BlockViewTracker.currentBlockViewState.updateBlockState({ blockId: blockId, blockName: blockInfo.blockName, blockType: blockInfo.blockType }, fraction);
            }
        });
    };
    BlockViewTracker.resetStateTimestamp = function (currentMillis) {
        BlockViewTracker.currentBlockViewState.setTimestampToNow(currentMillis);
    };
    BlockViewTracker.clearViewState = function () {
        BlockViewTracker.currentBlockViewState.clearViewState();
    };
    BlockViewTracker.snapshotBlockTimings = function () {
        BlockViewTracker.trackBlockState();
    };
    return BlockViewTracker;
}());
exports.default = BlockViewTracker;
